import {GetterTree} from 'vuex';
import {AdvertState} from '@/store/modules/Advert/state';
import {RootState} from '@/store';
import {Advert, AdvertType} from '#/Advert';
import {SearchOptions} from '#/Search';

export const getters: GetterTree<AdvertState, RootState> = {
  advert: (state: AdvertState): Advert => state.advert,
  adverts: (state: AdvertState): Advert[] => state.adverts,
  advertTypeItems: (state: AdvertState): AdvertType[] => state.advertTypeItems.slice(1),
  pageNumber: (state: AdvertState): number => state.pageNumber,
  searchOptions: (state: AdvertState): SearchOptions => state.searchOptions,
  typeFilter: (state: AdvertState): AdvertType | null => state.typeFilter,
  urlNextPage: (state: AdvertState): string | null => state.urlNextPage,
}
